import type { CartItem, DetailedSaleItem, CurrencyInfo } from '@src/domains/cart/types/cart';

export const calculatePackageTotal = <T extends DetailedSaleItem | CartItem>(
  items: T[],
  callback: (item: T) => number,
) => {
  return items.reduce((acc, item) => acc + callback(item), 0);
};

export const calculatePackageTotalCurrencyInfo = <T extends DetailedSaleItem | CartItem>(
  items: T[],
  callback: (item: T) => CurrencyInfo,
): CurrencyInfo => {
  return items.reduce(
    (acc, item) => {
      const currencyInfo = callback(item);
      return {
        amountCents: acc.amountCents + currencyInfo.amountCents,
        currency: currencyInfo.currency,
        originalAmountCents: acc.originalAmountCents + currencyInfo.originalAmountCents,
        originalCurrency: currencyInfo.originalCurrency,
      };
    },
    { amountCents: 0, currency: '', originalAmountCents: 0, originalCurrency: '' } as CurrencyInfo,
  );
};
